import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { loadReCaptcha } from 'react-recaptcha-v3';

import omit from 'lodash/omit';
import gettext from '@eb/gettext';

import { NotificationBar } from '@eb/eds-notification';
import { withMainControls } from '@eb/eds-structure';

import { AlertChunky } from '@eb/eds-iconography';
import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';
import { TYPE_ERROR } from '@eb/eds-notification';

import PageHeader from '../../components/PageHeader';
import SignupForm from '../../components/newForms/SignupForm';
import SplitContainer from '../../components/SplitContainer';

import { SIGN_UP_FORM } from '../../constants';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SIGN_UP_PATH
 */
class SignupPage extends React.PureComponent {
    static propTypes = {
        onSignUpUser: PropTypes.func,
        email: PropTypes.string,
        locale: PropTypes.string,
        moveBack: PropTypes.func,
        onLoginInsteadClick: PropTypes.func,
        trackEmailConfirmationEdit: PropTypes.func,
        trackEmailMismatchShowed: PropTypes.func,
        clearAuthNotification: PropTypes.func,
        recaptcha2PublicKey: PropTypes.string,
        recaptcha3PublicKey: PropTypes.string,
        disableRecaptcha3: PropTypes.bool,
        showCaptcha: PropTypes.bool,
        fp: PropTypes.bool,
        socialSSOSettings: PropTypes.shape({
            facebook: PropTypes.object,
        }),
        authNotificationOptions: PropTypes.shape({
            message: PropTypes.node,
            type: PropTypes.string,
            iconType: ICON_TYPE_PROP_TYPE,
        }),
    };

    componentDidMount() {
        if (!this.props.disableRecaptcha3) {
            loadReCaptcha(this.props.recaptcha3PublicKey);
        }
    }

    _handleSubmit = (formData) => {
        const { clearAuthNotification, onSignUpUser } = this.props;

        // clear notification everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        return onSignUpUser(formData);
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    };

    _renderAuthNotification = () => {
        const { authNotificationOptions } = this.props;

        let component = null;

        if (!isEmpty(authNotificationOptions)) {
            const { message, ...props } = authNotificationOptions;

            component = (
                <div className="eds-l-mar-top-4 eds-l-mar-bot-8 sign-in-screen__notification-container">
                    <NotificationBar {...props}>{message}</NotificationBar>
                </div>
            );
        }

        return component;
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;
        hideMainNotification && hideMainNotification();
    };

    render() {
        const {
            form,
            email,
            locale,
            recaptcha2PublicKey,
            showCaptcha,
            fp,
            socialSSOSettings,
            authNotificationOptions,
            shouldIncludeEmailConfirmation,
            clearAuthNotification,
            trackEmailConfirmationEdit,
            trackEmailMismatchShowed,
            onLoginInsteadClick,
        } = this.props;

        let syncErrors;

        if (form[SIGN_UP_FORM]) {
            syncErrors = form[SIGN_UP_FORM].syncErrors;
        }

        let pageHeaderProps = {
            headerText: gettext('Welcome'),
            subtitleText: gettext('Create an account.'),
        };
        const buttonCTA = gettext('Sign Up');

        // hide subtitle when an auth notification is being displayed
        if (!isEmpty(authNotificationOptions)) {
            pageHeaderProps = omit(pageHeaderProps, 'subtitleText');
        }

        return (
            <SplitContainer>
                <>
                    <PageHeader {...pageHeaderProps} />

                    {this._renderAuthNotification()}

                    <SignupForm
                        formErrors={syncErrors}
                        buttonCTA={buttonCTA}
                        onSubmit={this._handleSubmit}
                        onLoginInsteadClick={onLoginInsteadClick}
                        clearAuthNotification={clearAuthNotification}
                        locale={locale}
                        recaptcha2PublicKey={recaptcha2PublicKey}
                        showCaptcha={showCaptcha}
                        email={email}
                        fp={fp}
                        showNotification={this._handleShowNotification}
                        clearNotification={this._handleClearNotification}
                        socialSSOSettings={socialSSOSettings}
                        shouldIncludeEmailConfirmation={
                            shouldIncludeEmailConfirmation
                        }
                        trackEmailConfirmationEdit={trackEmailConfirmationEdit}
                        trackEmailMismatchShowed={trackEmailMismatchShowed}
                    />
                </>
            </SplitContainer>
        );
    }
}

export default withMainControls(SignupPage);
